import { CommandRequest } from "../../../libs/auth/utilities/command-request";
import { appApi } from "../../../store/app.api";
import { appEndpoint } from "../../../store/app.endpoint";

const PartnerApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    // Fetch all brands
    getPartners: build.query<any, void>({
      query: () => ({
        url: appEndpoint.partners,
        method: "get",
      }),
      providesTags: ["Partners"], // Tag for cache management
    }),

    // Create a new brand
    createPartner: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.partners,
        method: "post",
        data: data?.body,
      }),
      invalidatesTags: (result) => (result ? ["Partners"] : []),
    }),

    // Update existing brand
    updatePartner: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.partners}/${data?.id}?_method=put`,
        method: "post",
        data: data?.body,
      }),

    invalidatesTags: (result, error, { body }) => 
        result ? [{ type: 'Partners', id: body?.id }, "Partners"] : [],
    }),

    // Delete a brand
    deletePartner: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.partners}/${data?.id}`,
        method: "delete",
      }),

      invalidatesTags: (result, error, { body }) => 
        result ? [{ type: 'Partners', id: body?.id }, "Partners"] : [],
    }),
  }),
  overrideExisting: false,
});

// Export hooks for querying and mutating
export const {
  useGetPartnersQuery,
  useCreatePartnerMutation,
  useUpdatePartnerMutation,
  useDeletePartnerMutation,
} = PartnerApi;